
export class BieOnboardingApiError extends Error {
  public readonly statusCode?: number;

  public readonly code?: string;

  public readonly details?: unknown;

  public readonly originalError?: unknown;

  public constructor(
    message: string,
    options?: {
      statusCode?: number;
      code?: string;
      details?: unknown;
      originalError?: unknown;
    },
  ) {
    super(message);

    this.name =
      'BieOnboardingApiError';

    this.statusCode =
      options?.statusCode;

    this.code =
      options?.code;

    this.details =
      options?.details;

    this.originalError =
      options?.originalError;

    Object.setPrototypeOf(
      this,
      BieOnboardingApiError.prototype,
    );
  }
}
